import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { entityInbodyPinCodeService } from '../services/entityInbodyPinCodeService';
import { EntityInbodyPin } from '../interfaces/EntityInbodyPin';

class EntityInbodyPinCodeStore {
  pinCodeData: EntityInbodyPin | null = null;
  entityId: number | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.entityId = null;
    this.pinCodeData = null;
  }

  async getPin(entityId: number) {
    this.setEntityId(entityId);

    const pin = await entityInbodyPinCodeService.getPin(entityId);

    this.setPin(pin);
  }

  async upsertPin(pin: string) {
    if (!this.entityId) {
      throw new Error('Entity ID is not set');
    }

    const updatedPin = await entityInbodyPinCodeService.patchPin(this.entityId, { pin });

    this.setPin(updatedPin);
  }

  async togglePin(enabled: boolean) {
    if (!this.entityId) {
      throw new Error('Entity ID is not set');
    }

    const updatedPin = await entityInbodyPinCodeService.patchPin(this.entityId, {
      enabled,
    });

    this.setPin(updatedPin);
  }

  private setEntityId(entityId: number) {
    this.entityId = entityId;
  }

  private setPin(pin: EntityInbodyPin) {
    this.pinCodeData = pin;
  }
}

const entityInbodyPinCodeStore = new EntityInbodyPinCodeStore();

resetAllStore.addResetMethod(entityInbodyPinCodeStore.setDefaultValues);

export { entityInbodyPinCodeStore, EntityInbodyPinCodeStore };
